import { PureComponent } from "react";

import BaseListComponent from "/components/core/lists/base-list/base-list-component";

import BaseThumbnailItemComponent from "/components/core/thumbnails/base-thumbnail-item/base-thumbnail-item-component";

import { StyledThumbnailsListComponent } from "./thumbnails-list-component.scss";

export default class ThumbnailsListComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.filterValidator = this.filterValidator.bind(this);
    this.thumbnailRenderer = this.thumbnailRenderer.bind(this);
  }

  getItemFilterValue(thumbnailData) {
    return thumbnailData.props.title || "";
  }

  filterValidator(item) {
    const { filterTerm, filterValidator } = this.props;
    if (filterValidator) {
      return filterValidator(item);
    }

    const itemValue = this.getItemFilterValue(item);
    return itemValue.toLowerCase().indexOf(filterTerm.toLowerCase()) !== -1;
  }

  thumbnailRenderer(thumbnailData) {
    const { thumbnailType } = this.props;

    const { link } = thumbnailData.props;
    return (
      <BaseThumbnailItemComponent
        thumbnailType={thumbnailType}
        key={`${link}_${thumbnailData.props.title}`}
        {...thumbnailData.props}
      />
    );
  }

  render() {
    const { tuhmbnailsListData, filterTerm, emptyStateRenderer } = this.props;

    return (
      <StyledThumbnailsListComponent className="thumbnails-list-component">
        <BaseListComponent
          filterTerm={filterTerm}
          filterValidator={this.filterValidator}
          listData={tuhmbnailsListData}
          itemRenderer={this.thumbnailRenderer}
          emptyStateRenderer={emptyStateRenderer}
        />
      </StyledThumbnailsListComponent>
    );
  }
}
